import { Component, ElementRef, Injector, Input, OnInit } from '@angular/core';
import { FilesService } from '@services/files/files.service';
import { ComponentBase } from '@abstracts/component-base';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
})
export class SVGComponent implements OnInit {
  
  public className: string;

  public svg: any
  public size: number

  @Input() source: string
  @Input() height: number
  @Input() width: number

  constructor(
    private filesService: FilesService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    if (this.width >= 0) {
      this.size = this.width;
    } else {
      this.size = this.height;
    }
    this.filesService.getSVG(this.source).subscribe(result => {
      result = result.replace("width=\"24\"", "width=\"" + this.size + "\"");
      result = result.replace("height=\"24\"", "height=\"" + this.size+"\"");
      this.svg = this.sanitizer.bypassSecurityTrustHtml(result)

    }, error => {})
  }
}
